import PageHeader from "@/components/site/PageHeader";
import { ArrowRight } from "lucide-react";
import usePageTitle from "@/lib/usePageTitle";
import { HOSPITALITY } from "@/lib/constants";
import Reveal from "@/components/site/Reveal";

const POSTS = [
  {
    cat: "Listing Psychology",
    title: "Why your top three photos are quietly running your business.",
    excerpt: "Most owners obsess over the listing description. Guests are deciding before they ever read it.",
    date: "Coming Soon",
    img: HOSPITALITY.windowLight,
  },
  {
    cat: "Operational Clarity",
    title: "The friction guests feel before they articulate it.",
    excerpt: "A short observation on the small operational signals that quietly erode trust.",
    date: "Coming Soon",
    img: HOSPITALITY.hallway,
  },
  {
    cat: "Strategic Thinking",
    title: "What I look at first when reviewing a struggling listing.",
    excerpt: "It's rarely the description. It's almost always something quieter.",
    date: "Coming Soon",
    img: HOSPITALITY.textures,
  },
  {
    cat: "Calm Growth",
    title: "Systems don't limit your freedom — they create it.",
    excerpt: "A reflection on why operational structure is the foundation of business stability.",
    date: "Coming Soon",
    img: HOSPITALITY.workspace,
  },
];

export default function Blog() {
  usePageTitle("Journal");
  return (
    <div data-testid="page-blog" className="bg-ivory">
      <PageHeader
        overline="Journal"
        title="Reflections on strategy,"
        accent="systems & calm growth."
        description="A quiet space for observations, perspective shifts, and the small details that quietly shape strong businesses."
        testId="blog-header"
      />

      <section className="pb-24 lg:pb-32">
        <div className="container-editorial">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-14">
            {POSTS.map((p, i) => (
              <Reveal key={i} delay={(i % 2) * 100}>
              <article
                data-testid={`blog-post-${i}`}
                className="group cursor-pointer"
              >
                <div className="aspect-[4/3] overflow-hidden mb-6">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <p className="font-ui uppercase tracking-[0.18em] text-[13px] font-semibold text-sage mb-4">{p.cat} · {p.date}</p>
                <h2 className="font-serif text-2xl md:text-3xl text-navy leading-[1.2] group-hover:text-sage transition-colors">
                  {p.title}
                </h2>
                <p className="font-sans text-[15px] text-charcoal/75 mt-5 leading-[1.75]">{p.excerpt}</p>
                <span className="editorial-link mt-5 inline-flex">
                  Read More <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </article>
              </Reveal>
            ))}
          </div>

          <p className="font-ui text-center text-[12px] tracking-[0.18em] uppercase font-medium text-charcoal/55 mt-24">
            More reflections coming soon.
          </p>
        </div>
      </section>
    </div>
  );
}
